import { useTranslation as useTranslationOriginal } from "react-i18next";

export const useTranslation = () => {
  const { t, i18n } = useTranslationOriginal();

  const changeLanguage = (language: "en" | "fr") => {
    i18n.changeLanguage(language);
  };

  return {
    t,
    i18n,
    changeLanguage,
    currentLanguage: i18n.language as "en" | "fr",
  };
};
